module.exports = __webpack_public_path__ + "static/img/clothing_03.7e0bb30.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_03.png
// module id = MLT7
// module chunks = 0